import {
  CREATE_PRODUCT,
  DEACTIVE_PRODUCT,
  EDIT_PRODUCT,
  GET_CATEGORIES,
  GET_PRODUCT,
  GET_PRODUCT_NAMES,
  GET_PRODUCTS,
  GET_PRODUCTS_SUPPLIER,
  GET_SUB_CATEGORIES,
  PRODUCT_FILE,
  REACTIVE_PRODUCT,
  UNAVAILABLE_PRODUCT,
  ADD_PRODUCT_TO_ALL_STORES,
} from './ApiConstants';
import api from './ApiHandler';

export interface CreateProductPayloads {
  productImageUrl: string;
  productName: string;
  categoryId: string;
  subCategoryId: string;
  description: string;
  price: number;
  productType: string;
  productSKU: string;
  status: string;
  ingredients?: [];
  nutritions?: [];
}

export const getProductsList = async ({
  page,
  limit,
  entityId,
}: {
  page: number;
  limit: number;
  entityId: any;
}) => {
  return await api.get(GET_PRODUCTS, { params: { page, limit, entityId } });
};

export const createProduct = async (payload: any) => {
  return await api.post(CREATE_PRODUCT, { ...payload });
};

export const editProduct = async (payload: any) => {
  return await api.post(EDIT_PRODUCT, { ...payload });
};

export const getProductsByPage = async (payload: any) => {
  return await api.get(GET_PRODUCTS_SUPPLIER, { params: payload });
};

export const getProduct = async (payload: any) => {
  return await api.get(GET_PRODUCT, { params: payload });
};

export const reactiveProduct = async (payload: any) => {
  return await api.put(REACTIVE_PRODUCT, { ...payload });
};

export const deactiveProduct = async (payload: any) => {
  return await api.put(DEACTIVE_PRODUCT, { ...payload });
};

export const unAvailableProduct = async (payload: any) => {
  return await api.put(UNAVAILABLE_PRODUCT, { ...payload });
};

export const uploadFile = async (file: File, type: string) => {
  if (!file) {
    throw new Error('No file provided for upload.');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);

  let res = await api.post(PRODUCT_FILE, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return res;
};

export const getCategories = async ({ entityId }: { entityId: string }) => {
  return await api.get(GET_CATEGORIES, { params: { entityId } });
};

export const getSubCategories = async ({
  categoryId,
}: {
  categoryId: string;
}) => {
  return await api.get(GET_SUB_CATEGORIES, { params: { categoryId } });
};

export const getProductNames = async (payload: any) => {
  return await api.get(GET_PRODUCT_NAMES, { params: payload });
};

export const addProductToAllStores = async (payload: any) => {
  return await api.post(ADD_PRODUCT_TO_ALL_STORES, { ...payload });
};
